/**
 * Generated runtime TestId mirror for frontend/src/pages/MyDashboard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const MyDashboardTestIds = {
  approvalsCount: "approvals-count",
  cardTitleMyAccess: "card-title-my-access",
  cardTitleMyApprovals: "card-title-my-approvals",
  cardTitleMyRequests: "card-title-my-requests",
  linkMyAccess: "link-my-access",
  linkMyApprovals: "link-my-approvals",
  linkMyRequests: "link-my-requests",
  myAccessCount: "my-access-count",
  myDashboardPage: "my-dashboard-page",
  pendingRequestsCount: "pending-requests-count"
} as const;
